import React, { useRef } from 'react'
import { useReactToPrint } from 'react-to-print';
import { Row } from 'reactstrap';
import moment from 'moment';

//Components
import MainCard from 'components/MainCard/MainCard';

//Context
import { useAuth } from 'context/auth';
import CardRelatorio from '../components/CardRelatorio';
import mascaras from 'helpers/mascaras';

export default function RelatorioCertificadoDestinacaoResiduos({ dadosRelatorio, btnVoltar, filtros }) {
  //context
  const { session, setupVariavel } = useAuth();

  //Referencia para download do pdf
  const refRelatorio = useRef();

  //Função assionada assim que o botão de imprimir pdf é clicado
  const handlePrint = useReactToPrint({
      content: () => refRelatorio.current,
      copyStyles: true,
      documentTitle: "Certificado de Destinação de Resíduos",
  });

  //Cabeçalhos para a listagem dos locais de coletas
  const headersLocaisColetas = [
    { value: "LOCAL DE COLETA", objectValue: "localColeta", col: "12" },
  ];

  //Cabeçalhos para os totalizadores por destino
  const headersTotalizadoresManifestoTransporteResiduos = [
    { value: "Status", objectValue: "status", col: "4" },
    { value: `Quantidade`, objectValue: "quantidade", col: "4" },
    { value: "Percentual", objectValue: "percentual", col: "4" },
  ];

  //Cabeçalhos para os totalizadores por destino
  const headersTotalizadoresPorModalides = [
    { value: "Modalidade", objectValue: "modalidade", col: "3" },
    { value: `Informado`, objectValue: "informado", col: "3" },
    { value: "Gerado", objectValue: "gerado", col: "3" },
    { value: "Percertual", objectValue: "percetual", col: "3" },
  ];

  //Cabeçalhos para os totalizadores por destino
  const headersListaManifestoTransporteResiduos = [
    { value: `${setupVariavel?.siglaDocumentoColeta}`, objectValue: "numeroDocumento", col: "6" },
    { value: `Status`, objectValue: "status", col: "6" },
    { value: "Data Coleta", objectValue: "dataColeta", col: "6" },
    { value: "Data/Hora Destinação", objectValue: "dataHoraDestinacao", col: "6" },
    { value: "Transportador", objectValue: "transportador", col: "12" },
    { value: "Equipamento", objectValue: "equipamento", col: "12" },
    { value: "Modalidade/Quantitativo", objectValue: "modalidadeQuantitativo", col: "12" },
    { value: "Destino Final", objectValue: "destinoFinal", col: "12" },
  ];

  return (
    <MainCard btnVoltarInTop={btnVoltar} btnImprimir={handlePrint}>
      <div className="mt-4 relatorio w-100" ref={refRelatorio}>
          <div className="print m-2 d-flex align-items-center justify-content-between">
              <p>Emitido por: {session.nome}</p>
              <p>Data de emissão: {moment().format("DD/MM/YYYY HH:mm")}</p>
          </div>
          {setupVariavel?.logoTipo &&
              <div className="d-flex align-items-center justify-content-center">
                  <img src={"data:image/png;base64," + setupVariavel?.logoTipo} style={{ maxWidth: '70%'}} />
              </div>
          }
          <div className="header">
              <h4 className='text-black'>Certificado de Destinação de Resíduos</h4>
              <Row>
                  <div className='col-4'>
                      <p><span className="fw-bold">Período:</span> {moment(filtros.dataInicial).format("DD/MM/YYYY")} à {moment(filtros.dataFinal).format("DD/MM/YYYY")}</p>
                  </div> 
              </Row> 
          </div>
          <div className="body">

              <div className="contentGroup">
                  <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>DADOS DO GERADOR</h5>
                  <Row className='content-rel'>
                      <div className="col-6"><span className="fw-bold">CNPJ:</span> {dadosRelatorio?.gerador ? mascaras.cpfcnpjMask(dadosRelatorio?.gerador?.cpfcnpj) : ""}</div>
                      <div className="col-6"><span className="fw-bold">E-mail:</span> {dadosRelatorio?.gerador?.email ?? ""}</div>
                      <div className="col-4"><span className="fw-bold">Fantasia:</span> {dadosRelatorio?.gerador?.fantasia  ?? ""}</div>
                      <div className="col-4"><span className="fw-bold">Telefone:</span> {dadosRelatorio?.gerador?.telefone  ?? ""}</div> 
                      <div className="col-4"><span className="fw-bold">Razão Social:</span> {dadosRelatorio?.gerador?.razaoSocial  ?? ""}</div> 
                  </Row>
              </div>

              <div className="contentGroup">
                  <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>LOCAIS DE COLETA</h5>
                  <CardRelatorio 
                        headers={headersLocaisColetas} 
                        items={dadosRelatorio?.listaLocaisColetas.map(value => {
                          return { localColeta: value };
                        }) || []}
                   />
              </div> 

              <div className="contentGroup">
                  <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>
                    <div className='d-flex justify-content-between align-items-center'>
                      TOTALIZADORES DE MANIFESTO DE TRANSPORTE DE RESÍDUOS 
                      <p ><span className="fw-bold"></span>{dadosRelatorio?.totalColetas ?? 0}</p>
                    </div>
                  </h5>
                  <CardRelatorio 
                    headers={headersTotalizadoresManifestoTransporteResiduos} 
                    items={dadosRelatorio?.totalizadoresManifestoTransporteResiduos || []} 
                  />
              </div> 

              <div className="contentGroup">
                  <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>TOTALIZADOR POR MODALIDADE</h5>
                  <CardRelatorio 
                    headers={headersTotalizadoresPorModalides} 
                    items={dadosRelatorio?.totalizadoresPorModalidades || []} 
                  />
              </div> 

              <div className="contentGroup">
                <Row className='content-rel'>
                    <div className="col-5"><span className="fw-bold">Gerado</span></div>
                    <div className="col-4"><span className="fw-bold">Destinado</span></div>
                    <div className="col-3"><span className="fw-bold">% Declarado</span></div>

                    <div className="col-5"><span className="fw-bold">{dadosRelatorio?.totalGerado ?? 0}</span></div>
                    <div className="col-4"><span className="fw-bold">{dadosRelatorio?.totalDestinado ?? 0}</span></div>
                    <div className="col-3"><span className="fw-bold">{dadosRelatorio?.porcetagemDeclarada }</span></div>
                </Row>
              </div> 

              <div className="contentGroup avoid-break">
                  <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>LISTA DE {setupVariavel?.siglaDocumentoColeta}S</h5>
                  <CardRelatorio 
                    headers={headersListaManifestoTransporteResiduos} 
                    items={dadosRelatorio?.listaManifestoTransporteResiduos || []} 
                  />
              </div> 

              <div className="contentGroup">
                <Row className='content-rel'>
                    <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>ASSINATURA DIGITAL</h5>
                    <div className="col-12 text-secondary"><span className="fw-bold">{dadosRelatorio?.assinaturaDigital}</span></div>
                </Row>
              </div> 
          </div>
        </div>
    </MainCard>
  )
}
